import axios from "axios";

/**
 * Bare client for the unauthenticated auth endpoints (exchange, refresh,
 * logout). Deliberately NOT the configured instance from src/config/axios:
 *
 *   - its request interceptor would attach an access token these endpoints
 *     neither need nor want (for /refresh it is dead by definition)
 *   - its response interceptor turns every 401 into a refresh attempt, so a
 *     plain `CODE_USED` from /exchange would recurse into the refresh manager
 *     and end the session with the wrong message
 */
const authClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL + "/api/v1",
  timeout: 20000,
});

export default authClient;
